import { appendElement, appendElementIf } from '../xml-helpers';

function parseIsoDate(dateStr: string): {
  year: string;
  month?: string;
  day?: string;
} {
  const parts = dateStr.split('-');
  return {
    year: parts[0],
    month: parts[1],
    day: parts[2],
  };
}

/** Builds a date element with optional month, day, and required year. */
export function buildDate(
  parent: Element,
  elementName: string,
  dateStr: string,
  attrs?: Record<string, string>
): Element {
  const { year, month, day } = parseIsoDate(dateStr);
  const dateEl = appendElement(parent, elementName, null, attrs);
  appendElementIf(dateEl, 'month', month);
  appendElementIf(dateEl, 'day', day);
  appendElement(dateEl, 'year', year);
  return dateEl;
}

export function buildPublicationDate(
  parent: Element,
  dateStr: string,
  mediaType: 'online' | 'print'
): Element {
  return buildDate(parent, 'publication_date', dateStr, {
    media_type: mediaType,
  });
}

export function buildPublicationDates(
  parent: Element,
  dates: { online?: string; print?: string }
): void {
  if (dates.online) {
    buildPublicationDate(parent, dates.online, 'online');
  }
  if (dates.print) {
    buildPublicationDate(parent, dates.print, 'print');
  }
}
